import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Row } from 'react-bootstrap';

const styles = {
    rootContainer: {
        position: 'relative',
        width: '100%',
        marginLeft: 0,
        marginRight: 0
    },
    contentContainer: {
        marginLeft: 'auto',
        marginRight: 'auto'
    }
};

export default class FullWidthRow extends Component {
    static propTypes = {
        backgroundColor: PropTypes.string,
        children: PropTypes.node,
        maxContentWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        style: PropTypes.object
    };

    static defaultProps = {
        backgroundColor: 'transparent'
    };

    getRootContainerStyle() {
        return {
            ...styles.rootContainer,
            ...this.props.style,
            backgroundColor: this.props.backgroundColor
        };
    }

    getContentContainerStyle() {
        return {
            ...styles.contentContainer,
            maxWidth: this.props.maxContentWidth
        };
    }

    render() {
        return (
            <Row style={this.getRootContainerStyle()}>
                <div style={this.getContentContainerStyle()}>{this.props.children}</div>
            </Row>
        );
    }
}
